export const DEFAULT_AUDIENCE = {
  audienceAges: [
    {
      key: 'all',
      value: '',
      label: 'All Ages',
      filterName: 'Ages',
      buttonLabel: 'All',
      tolgee: {
        key: 'global-all',
        defaultValue: 'All',
      },
    },
  ],
  audienceGenders: {
    key: 'all',
    value: '',
    label: 'All',
    filterName: 'Genders',
    tolgee: {
      key: 'global-all',
      defaultValue: 'All',
    },
  },
  audienceCountries: {
    key: 'all',
    value: '',
    label: 'Worldwide',
    filterName: 'Countries',
  },
}
